import { type JSX, useEffect } from 'react';
import { Outlet, useNavigation } from 'react-router';

import HydrateFallback from '@/components/common/hydrate-fallback';
import useClientStore from '@/features/client/stores/client-store';
import useThemeStore from '@/features/theme/stores/theme-store';
import { ClientTheme } from '@/features/theme/types/theme';

export const Nh1816Layout = (): JSX.Element => {
  const { setClientTheme } = useThemeStore();
  const { setClient } = useClientStore();

  useEffect(() => {
    setClientTheme(ClientTheme.NH1816);
  }, [setClientTheme]);

  useEffect(() => {
    setClient({
      locale: 'nl-NL',
      currency: 'EUR',
      language: 'nl',
      country: 'NL',
    });
  }, [setClient]);

  const { state } = useNavigation();

  // Show the loading fallback when router loader is loading.
  if (state === 'loading') {
    return <HydrateFallback />;
  }

  return <Outlet />;
};
